import mark from './TMark/loader'
import node from './TNode/loader'
import nodeAttr from './TNodeAttr/loader'

export default {
  mark,
  node,
  nodeAttr,
}
